namespace $ {
	
	export function $mol_test_complete() {
		process.exit(0)
	}
	
}
